import { RatingLevelsDefinition } from './rating-levels-definition';

export class RatingLevelsDefinitions {
  public static A: RatingLevelsDefinition = {
    levels: ['negligible', 'very_low', 'low', 'significant', 'high', 'very_high', 'extreme', 'unacceptable'],
    greenLevels: ['negligible', 'very_low', 'low'],
    orangeLevels: ['significant', 'high', 'very_high'],
    redLevels: ['extreme', 'unacceptable'],
    criticalLevels: ['extreme', 'unacceptable']
  };

  public static B: RatingLevelsDefinition = {
    levels: ['very_low', 'low', 'medium', 'high', 'very_high'],
    greenLevels: ['very_low', 'low'],
    orangeLevels: ['medium'],
    redLevels: ['high', 'very_high'],
    criticalLevels: ['high', 'very_high']
  };

  public static C: RatingLevelsDefinition = {
    levels: ['eliminated', 'unacceptable'],
    greenLevels: ['eliminated'],
    orangeLevels: [],
    redLevels: ['unacceptable'],
    criticalLevels: ['unacceptable']
  };

  public static D: RatingLevelsDefinition = {
    levels: ['negligible', 'low', 'medium', 'substantial', 'high', 'critical'],
    greenLevels: ['negligible', 'low'],
    orangeLevels: ['medium', 'substantial'],
    redLevels: ['high', 'critical'],
    criticalLevels: ['high', 'critical']
  };

  public static E: RatingLevelsDefinition = {
    levels: ['negligible', 'low', 'medium', 'substantial', 'high', 'critical'],
    greenLevels: ['negligible', 'low'],
    orangeLevels: ['medium', 'substantial'],
    redLevels: ['high', 'critical'],
    criticalLevels: ['high', 'critical']
  };

  public static merged: RatingLevelsDefinition = {
    levels: ['eliminated', 'negligible', 'very_low', 'low', 'significant', 'medium', 'high', 'very_high', 'extreme', 'unacceptable'],
    greenLevels: ['eliminated', 'negligible', 'very_low', 'low'],
    orangeLevels: ['significant', 'medium', 'high'],
    redLevels: ['very_high', 'extreme', 'unacceptable'],
    criticalLevels: ['very_high', 'extreme', 'unacceptable']
  };

  public static mergedAmazon: RatingLevelsDefinition = {
    levels: [
      'eliminated',
      'negligible',
      'very_low',
      'low',
      'significant',
      'medium',
      'substantial',
      'high',
      'very_high',
      'extreme',
      'critical',
      'unacceptable'
    ],
    greenLevels: ['eliminated', 'negligible', 'very_low', 'low'],
    orangeLevels: ['significant', 'medium', 'substantial', 'high'],
    redLevels: ['very_high', 'extreme', 'critical', 'unacceptable'],
    criticalLevels: ['very_high', 'extreme', 'critical', 'unacceptable']
  };
}
